import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PartnerRelationship } from '../../models/PartnerRelationship';
import { Subscription, Subject } from 'rxjs';
import { RelationshipType, RelationshipData, RelationshipDataItem } from '../../models/partner';
import { PartnerUser, Privilege, PrivilegeGroup} from '../../models';
import { PrivilegeService } from '../../privilege.service';
import { PartnerService } from '../../partner-service';
import { Person } from '../../models/Person';
import { PartnershipService } from '../../partnership.service';
@Component({
  selector: 'app-add-partnership',
  templateUrl: './add-partnership.component.html',
  styleUrls: ['./add-partnership.component.scss']
})
export class AddPartnershipComponent implements OnInit, OnDestroy {

  @Input() displayAddDialog: boolean;
  @Output() onDialogOpen = new EventEmitter<boolean>();
  @Output() onDialogClose = new EventEmitter<boolean>();
  @Output() onRelationships = new EventEmitter<PartnerRelationship[]>();
  @Output() onError = new EventEmitter<string>();

  partnerTypes: RelationshipType[]; // List of Relationship types
  partnerTypeSelected: RelationshipType;  // Relationship Type selected
  partners: RelationshipData[];  // list of source partners for a Relationship Type
  partnerSelected: RelationshipData;
  availableGroup: RelationshipDataItem[]; // List of asset groups
  selectedGroup: RelationshipDataItem[];
  partnerUser: PartnerUser;
  person: Person;
  partnerListLoading = false;
  partnerCreate: PartnerRelationship;
  partnerRelationships: PartnerRelationship[];
  subscription: Subscription;
  assetSubscription: Subscription;
  processing = false;
  searchInput: string;
  assetGroupLoading = false;
  assetIdSearch: Subject<string> = new Subject<string>();
  assetIdCount = 0;
  relationshipTypePrivileges: Privilege[] = [];
  selectedItemsNow: any[] = [];
  partnershipTypePrivileges: any[] = [];

  constructor(private partnerSvc: PartnerService, private partnershipSvc: PartnershipService,
    private partnerPrivilegeSvc: PrivilegeService) {}

  ngOnInit() {
    this.availableGroup = [];
    this.selectedGroup = [];
    // Prepopulate the list of Relationship types
    this.populateRelationshipTypes();
    this.person = new Person();
    this.partnerUser = new PartnerUser();
  }

  relationshipTypePrivilege(): void {
    this.partnerPrivilegeSvc.findByRelationshipTypeID(this.partnerTypeSelected.RelationshipTypeId)
      .subscribe((relationships) => {
        this.partnershipTypePrivileges = (relationships as any).data;
        // retrieving unique Partnership Type privileges based on groups privileges and privileges
        this.relationshipTypePrivileges = this.partnerSvc.getUniquePrivileges(this.partnershipTypePrivileges[0].PrivilegeGroups,
          this.partnershipTypePrivileges[0].Privileges);
      });
  }

  privilegeChange(privilege): void {
   this.selectedItemsNow = privilege.Privileges;
  }

  dialogClose(addPartnerForm: NgForm): void {
    this.onDialogClose.emit(false);
    // Reset all the form values when we close the dialog
    this.resetOtherFields();
    addPartnerForm.reset();
  }

  dialogOpen(): void {
    this.onDialogOpen.emit(true);
  }

  cancelDialog(): void {
    this.displayAddDialog = false;
  }

  populateRelationshipTypes(): void {
    this.subscription = this.partnershipSvc
        .findTypes()
        .subscribe((types)  => {
        this.partnerTypes = types['data'];
      });
  }

  partnerTypechange(): void {
    this.partners = [];
    this.partnerSelected = null;
    if (this.assetSubscription) { this.assetSubscription.unsubscribe(); }
    this.assetSubscription = this.partnerSvc
      .assetGroupSearchObservable(this.assetIdSearch, this.partnerTypeSelected)
      .subscribe((res: any)  => {
        this.assetIdCount = (res.meta.pagination.TotalRecords) ? res.meta.pagination.TotalRecords : 0;
        const aSelectedId = this.selectedGroup.map(item => item.ItemId);
        this.availableGroup = res.data.filter(item => aSelectedId.indexOf(item.ItemId) === -1);
        this.assetGroupLoading = false;
    }, error => {
      this.assetGroupLoading = false;
    });

    this.relationshipTypePrivilege();
  }

  onSubmit(AddPartnerForm: NgForm): void {
    if (AddPartnerForm.valid) {
      this.processing = true;
      this.createPartner();
      this.onRelationships.emit(this.partnerRelationships);
    }
  }

  createPartner(): void {
    this.populatePartnerCreate();
    this.subscription = this.partnerSvc.create(this.partnerCreate)
      .subscribe((relationships)  => {
        this.displayAddDialog = false;
        this.partnerRelationships = relationships['data'];
        this.onRelationships.emit(this.partnerRelationships);
        this.processing = false;
    }, error => {
      this.processing = false;
      this.displayAddDialog = false;
      this.onError.emit('Error Occcured while Processing');
    });
  }

  populatePartnerCreate(): void {
    this.partnerCreate = new PartnerRelationship();
    this.partnerCreate.IsActive = false;
    this.partnerCreate.RelationshipType = this.partnerTypeSelected;
    this.partnerCreate.ChildCompany = {'CompanyId': 0, Name: this.partnerSelected.ItemCompanyName };
    this.partnerUser.IsPrimary = true;
    this.partnerCreate.PartnerUser = [this.partnerUser];
    this.partnerUser.Privileges = this.selectedItemsNow;
    this.partnerUser.Person = this.person;
    this.partnerCreate.MasterDataKeys = this.selectedGroup;
    this.partnerCreate.Privileges = this.selectedItemsNow;
  }

  partnerSearch(event): void {
    this.partnerListLoading = true;
    if (this.partnerTypeSelected) {
      this.subscription = this.partnerSvc
          .getSourcePartners(event.query, this.partnerTypeSelected)
          .subscribe((res)  => {
          this.partners = res.data;
          this.partnerListLoading = false;
      });
    }
  }

  searchTextInput(value): void {
    this.assetIdSearch.next(value);
    this.assetGroupLoading = true;
  }

  partnerChange() {
    this.searchInput = this.partnerSelected.ItemCompanyName.slice(0, 5);
    this.assetIdSearch.next(this.searchInput);
    this.assetGroupLoading = true;
  }

  resetOtherFields(): void {
    this.partnerTypeSelected = null;
    this.partnerSelected = null;
    this.partners = null;
    this.availableGroup = null;
    this.selectedGroup = [];
  }

  ngOnDestroy() {
    if(this.subscription) { this.subscription.unsubscribe(); }
    if(this.assetIdSearch) { this.assetIdSearch.unsubscribe(); }
    if(this.assetSubscription) { this.assetSubscription.unsubscribe(); }
  }

}
